// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__270VT","content":"styles_content__3BoJH","header":"styles_header__bLKTt","overviewHeader":"styles_overviewHeader__2yQsO"};